export interface SwiperImgUrlDto {
    imgUrl: string;
}

export const SwiperImgUrl = [
    {
        imgUrl: './img/swiper_img_1.png'
    },
    {
        imgUrl: './img/swiper_img_2.png'
    },
    {
        imgUrl: './img/swiper_img_3.png'
    },
    {
        imgUrl: './img/swiper_img_4.png'
    },
    {
        imgUrl: './img/swiper_img_5.png'
    }
]